module.exports = __webpack_public_path__ + "media/images/athletes/27-9a8c539591c1cca5d85fd4b5d1bc1f29.png";